import React from "react";
import Overlay from "../Overlay";
import {sweetalert} from "../../App";
import SimpleTable from "../tables/SimpleTable";
import BatchesAPI, {SampleBatchInfo} from "../../network/BatchesAPI";
import Batch from "../../types/Batch";
import {BatchSelect} from "./selects/BatchSelect";
import {Column} from "../tables/TableBase";
import {Sorter, TableOrder} from "../../sorting/Sorter";
import ServicesAPI from "../../network/ServicesAPI";
import ResultsAPI from "../../network/ResultsAPI";
import { getNamesFromIDs } from "../../util/FormatUtil";
import SamplesAPI from "../../network/SamplesAPI";
import PaginationTool from "../PaginationTool";
import { isInTieredGroup } from "../../types/Service";

interface BatchState{
    batchID?:number
    showLoading?
    batches?
    samples:SampleBatchInfo[]
    direction: TableOrder
    services
    results
    tests
    isDTC
}
export class BatchReporting extends React.Component<{ }, BatchState>{

    constructor(props) {
        super(props);
        this.state = {
            showLoading:true,
            batches:[],
            samples:[],
            direction: 'asc',
            services: [],
            results: [],
            tests: [],
            isDTC: false,
        };
        this.submit = this.submit.bind(this);
    }

    async componentDidMount() {
        let services = await ServicesAPI.getAllServicesForMachineExport();
        if (!services.success) {
            return sweetalert.fire({
                title: 'Error',
                text: services.reason,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
        this.setState({services: services.data.filter(s => s.ExportParseURL && s.IsEnabled)})

        let results = await ResultsAPI.getAllResultsData();
        if (!results.success) {
            return sweetalert.fire({
                title: 'Error',
                text: results.reason,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
        this.setState({results: results.data.results, tests: results.data.tests})

        BatchesAPI.getAllBatches().then((data) => {
            this.setState({ batches: data });
          });
    }

    onBatchChange = async (batchID:number) => {
        this.setState({batchID:batchID, showLoading:true, isDTC:false}, async() =>{
            let response = await BatchesAPI.getSamplesByBatchID(batchID);
            if(!response.success){
                await sweetalert.fire({icon: 'error', title: '', text: response.reason});
            }else if(response.samples.length === 0){
                await sweetalert.fire({icon: 'error', title: '', text: "No samples found in batch"});
            }else {
                let selectedService = this.state.services.find(s => s.ID === response.samples?.[0]?.ServiceID)
                if (selectedService?.ReportType === 5 ) {
                    this.setState({isDTC:true})
                }
                this.setState({samples:response.samples});
            }
            this.setState({showLoading:false});
        });
    }

    async submit(){
        if( !this.state.batchID){
            return sweetalert.fire({icon: 'error', title: '', text: "Please select a batch"});
        }
        const batch = this.state.batches.find(f => f.ID === this.state.batchID);
        const service = this.state.services.find(f => f.ID === batch.ServiceID)
        const providerCommOnly = service.EmailReportTo === 1 ? true : false;
        if(!providerCommOnly){
            let sampleSpecimenIDs = this.state.samples.map(s => {return s.SpecimenID});
            let commSamples = [];
            let getSamplesReturn = await SamplesAPI.getSamplesBasedOnSpecimenID(sampleSpecimenIDs);
            commSamples = commSamples.concat(getSamplesReturn.data)

            let samplesWithoutEmail = []
            for (let i = 0; i < commSamples.length; i++) {
                if(!commSamples[i].PatientEmail){
                    samplesWithoutEmail.push(commSamples[i].SpecimenID)
                }
            }

            if(samplesWithoutEmail && samplesWithoutEmail.length > 0){
                sweetalert
                .fire({
                icon: 'warning',
                title: "",
                html: `<h4>No email found in sample record</h4><p style="margin-top: 20px;">${samplesWithoutEmail.length === 1 ? 'Results will not be sent for Specimen ID' : 'Results will not be sent for Specimen IDs'}: ${samplesWithoutEmail.join(', ')}</p>`,
                showCloseButton: false,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Continue",
                denyButtonText: `Go Back`,
                denyButtonColor: 'green',
                })
                .then((result) => {
                    if(result.isDenied){
                        return
                    }
                    else{
                        this.setState({showLoading:true,}, async()=>{
                            let response = await BatchesAPI.approveBatch(this.state.batchID);
                            if(response.success){
                                await sweetalert.fire({icon: 'success', title: '', text: response.reason});
                            }else{
                                await sweetalert.fire({icon: 'error', title: '', text: response.reason});
                            }
                            this.setState({showLoading:false});
                        })
                    }
                })
            }
            else{
                this.setState({showLoading:true,}, async()=>{
                    let response = await BatchesAPI.approveBatch(this.state.batchID);
                    if(response.success){
                        await sweetalert.fire({icon: 'success', title: '', text: response.reason});
                    }else{
                        await sweetalert.fire({icon: 'error', title: '', text: response.reason});
                    }
                    this.setState({showLoading:false});
                }) 
            }
        }
        else{
            this.setState({showLoading:true,}, async()=>{
                let response = await BatchesAPI.approveBatch(this.state.batchID);
                if(response.success){
                    await sweetalert.fire({icon: 'success', title: '', text: response.reason});
                }
                else{
                    await sweetalert.fire({icon: 'error', title: '', text: response.reason})
                }
                this.setState({showLoading: false})
        })
    }}

    useSorter(col:Column){

        if(col.key === 'TestIDs' || col.key === 'ResultIDs'){

            let samplesCopy = JSON.parse(JSON.stringify(this.state.samples))
            
            samplesCopy.map(sc => {
                let parsedIDsArray = col.key === 'TestIDs' ? JSON.parse(sc.TestIDs) : col.key === 'ResultIDs' ? JSON.parse(sc.ResultIDs) : null
                sc.Names =  parsedIDsArray && col.key === 'TestIDs' ? getNamesFromIDs(parsedIDsArray, this.state.tests) : parsedIDsArray && col.key === 'ResultIDs' ? getNamesFromIDs(parsedIDsArray, this.state.results) : null
            })

            let sortedSamples;
            if(this.state.direction === 'asc'){
                sortedSamples = samplesCopy.sort((a, b) => a.Names[0].localeCompare(b.Names[0]))
            }
            else{
                sortedSamples = samplesCopy.sort((a, b) => b.Names[0].localeCompare(a.Names[0]))
            }

            delete sortedSamples.Names

            this.setState({samples: sortedSamples, direction: this.state.direction === 'asc' ? 'desc' : 'asc'})
        }
        else{
            let sorter = new Sorter<any>()
            this.setState({samples: sorter.sortByKey(this.state.samples, col.key as keyof any,this.state.direction), direction: this.state.direction === 'asc' ? 'desc' : 'asc'});
        }

        

        
    }

    render() {

        let isEssentialOrComprehensive = false;
        if (this.state.samples && this.state.samples.length > 0 && this.state.services && this.state.services.length > 0) {
            const sampleService = this.state.services.find(s => s.ID === this.state.samples[0].ServiceID);
            if (sampleService) {
                isEssentialOrComprehensive = isInTieredGroup(sampleService, this.state.services);
            }
        }

        return <React.Fragment>
            <PaginationTool />
            <Overlay show_loading={this.state.showLoading}/>
            <div className="container-fluid">
                <div className={"row"}>
                    <div className="col-xl-5 col-lg-8 col-md-12 col-12 pt-2">
                        <div className="card mb-2">
                            <div className="card-header verlag-bold">
                                <h4>Batch Reporting</h4>
                            </div>
                            <div className={"card-body"}>
                                <BatchSelect onSelected={(e:{label, value:Batch}) => this.setState({batchID:e.value.ID}, async () =>{
                                    await this.onBatchChange(this.state.batchID)
                                })} finishedLoading={() => this.setState({showLoading:false})}
                                value={this.state.batchID ? 1 : null}/>
                                <br/>
                            </div>
                        </div>
                    </div>
                    {this.state.samples.length > 0 && (
                    <div className="col-12 pt-2">
                        <a id={"top"}>{}</a>
                        <div className="card mt-2 mb-5">
                            <div className="card-header verlag-bold stickToTop">
                                <h4 className="text-center text-md-left">
                                    Batch Records
                                    <button
                                        className={this.state.samples.length > 0 ?"btn immySubmitButtonOutline ml-3 float-right" : "invisible"}
                                        onClick={this.submit}
                                        >
                                        Send Results
                                    </button>
                                    <h4 className={"float-right"}>
                                        Total: {this.state.samples.length}
                                    </h4>
                                </h4>
                            </div>
                            <div className="card-body p-0 m-0 table-responsive">
                                {isEssentialOrComprehensive || this.state.isDTC ? 
                                    <SimpleTable  table_style="tableFixHead" columns={[
                                        {label:"Specimen ID", key:"SpecimenID"},
                                        {label:"Internal Specimen ID", key:"InternalSpecimenID"},
                                        {label:"Well Slot", key:"WellSlot"},
                                        {label: "Tests", key: "TestIDs", rawFormat: (val) => {
                                            let labels = []
                                            let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                            if(testsAndResultsMap.length > 0){
                                                let testName;
                                                testsAndResultsMap.map(t => {
                                                    testName = this.state.tests.find(f => f.ID === t.TestID).Name
                                                    labels.push(testName)
                                                })
                                                
                                            }
                                            return labels && labels.map(m => (
                                                <p className="mb-0">{m}</p>
                                            ))
                                        }},
                                        {label: this.state.isDTC ? "Detection Level" : "Result Values", key: "", rawFormat: (val) => {
                                            let labels = []
                                            let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                            if(testsAndResultsMap.length > 0){
                                                let resultValue;
                                                testsAndResultsMap.map(t => {
                                                    resultValue = t.ResultValue || t.ResultValue === 0 ? t.ResultValue : null
                                                    labels.push(resultValue)
                                                })
                                                
                                            }
                                            return labels && labels.map(m => (
                                                <p className="mb-0">{Object.hasOwn(testsAndResultsMap[0], 'ResultValue') ? m : 'N/A'}</p>
                                            ))
                                        }},
                                         {label: this.state.isDTC ? "Population Percentile" : "Relative Abundance", key: "", rawFormat: (val) => {
                                                let labels = []
                                                let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                                if(testsAndResultsMap && testsAndResultsMap.length > 0){
                                                    let relativeAbundance;
                                                    testsAndResultsMap.map(t => {
                                                        relativeAbundance = t.RelativeAbundance || t.RelativeAbundance === 0 ? t.RelativeAbundance : null
                                                        labels.push(relativeAbundance)
                                                    })
                                                    
                                                }
                                                return labels && labels.map(m => (
                                                    <p className="mb-0">{testsAndResultsMap[0] && Object.hasOwn(testsAndResultsMap[0], 'RelativeAbundance') ? m : 'N/A'}</p>
                                                ))
                                            }}
                                    ]} 
                                        table_data={this.state.samples} columnClickedCallback={(col =>{
                                        this.useSorter(col);
                                    })}/>
                                : 
                                    <SimpleTable columns={[
                                        {label:"Specimen ID", key:"SpecimenID"},
                                        {label:"Internal Specimen ID", key:"InternalSpecimenID"},
                                        {label:"Well Slot", key:"WellSlot"},
                                        {label: "Tests", key: "TestIDs", rawFormat: (val) => {
                                            let labels = []
                                            let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                            if(testsAndResultsMap.length > 0){
                                                let testName;
                                                testsAndResultsMap.map(t => {
                                                    testName = this.state.tests.find(f => f.ID === t.TestID).Name
                                                    labels.push(testName)
                                                })
                                                
                                            }
                                            return labels && labels.map(m => (
                                                <p className="mb-0">{m}</p>
                                            ))
                                        }},
                                        {label: "Results", key: "ResultIDs", rawFormat: (val) => {
                                            let labels = []
                                            let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                            if(testsAndResultsMap.length > 0){
                                                let resultName;
                                                testsAndResultsMap.map(t => {
                                                    resultName = this.state.results.find(r => r.ID === t.ResultID).Value
                                                    labels.push(resultName)
                                                })
                                                
                                            }
                                            return labels && labels.map(m => (
                                                <p className="mb-0">{m}</p>
                                            ))
                                        }},
                                        {label: "Result Values", key: "ResultValues", rawFormat: (val) => {
                                            let labels = []
                                            let testsAndResultsMap = val.TestsAndResultsMap ? JSON.parse(val.TestsAndResultsMap) : [];
                                            if(testsAndResultsMap.length > 0){
                                                let resultValue;
                                                testsAndResultsMap.map(t => {
                                                    resultValue = t.ResultValue || t.ResultValue === 0 ? t.ResultValue : null
                                                    labels.push(resultValue)
                                                })
                                                
                                            }
                                            return labels && labels.map(m => (
                                                <p className="mb-0">{Object.hasOwn(testsAndResultsMap[0], 'ResultValue') ? m : 'N/A'}</p>
                                            ))
                                        }}]} 
                                        table_data={this.state.samples} columnClickedCallback={(col =>{
                                        this.useSorter(col);
                                    })}/>
                                }
                                
                            </div>
                        </div>
                    </div>
                    )}
                </div>        
            </div>
        </React.Fragment>
    }
}